import React, {useState} from 'react';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {Button, Table} from "react-bootstrap";

import moment from "moment/moment";

import "../../css/OrderDeliveryDetail.css";
import {
  showPopinOrderCredit,
  showPopinReprepareOrderBefore,
  showPopinReDeliverOrder,
  showPopinRefundOrder
} from "../../actions";
import {isRedeliverStillInTime} from "../../../dispatch/utils/order";
import {isMarketplaceOrder} from "../../../../utils/marketplace";
import {
  canRefundOrder,
  MARGE_DEPASSEMENT_TTC,
  orderRemainingRecreditAmountRaw,
} from "../../utils";
import {PaymentLinkModal} from "./modals/PaymentLinkModal";

const InternalOrderActions = ({
  order,
  user,
  showPopinCredit,
  showPopinReprepare,
  showPopinReDeliver,
  showPopinRefund,
  readOnly,
}) => {
  const [showPaymentLinkModal, setShowPaymentLinkModal] = useState(false);

  if (!order) {
    return null;
  }

  moment.locale('fr');

  const fullyCompensated =
    orderRemainingRecreditAmountRaw(order) + MARGE_DEPASSEMENT_TTC <= 0;

  return <React.Fragment>
    <Table size="sm" hover className="OrderActions">
      <tbody>
        <tr><th colSpan={2}>Actions possibles</th></tr>
        <tr>
          <td></td>
          <td>
            <Button
              variant="primary"
              size="xs"
              onClick={() => showPopinCredit(order, user) }
              disabled={
                readOnly
              || order.updating
              || isMarketplaceOrder(order)
              || fullyCompensated
              }
              title={fullyCompensated
                ? `Commande déjà intégralement dédommagée (montant total + marge de ${MARGE_DEPASSEMENT_TTC} €)`
                : undefined}
            >
            Dédommagement
            </Button>
          </td>
        </tr>
        {
          ["shipping", "received"].includes(order.status) &&
        <tr>
          <td></td>
          <td>
            <Button
              variant="primary"
              size="xs"
              onClick={() => showPopinReprepare(order) }
              disabled={order.updating || isMarketplaceOrder(order)}
            >
              Repréparer la commande
            </Button>
          </td>
        </tr>
        }
        {
          ["shipping", "received"].includes(order.status) && isRedeliverStillInTime(order) &&
        <tr>
          <td></td>
          <td>
            <Button
              variant="primary"
              size="xs"
              onClick={() => showPopinReDeliver(order)}
              disabled={order.updating || isMarketplaceOrder(order)}
            >
              Relivrer le(s) sac(s) oublié(s)
            </Button>
          </td>
        </tr>
        }
        {
          canRefundOrder(order) &&
        <tr>
          <td></td>
          <td>
            <Button
              variant="warning"
              size="xs"
              onClick={() => showPopinRefund(order)}
              disabled={order.updating || isMarketplaceOrder(order)}
            >
              Remboursement
            </Button>
          </td>
        </tr>
        }
        <tr>
          <td></td>
          <td>
            <Button
              variant="primary"
              size="xs"
              onClick={() => setShowPaymentLinkModal(true)}
              disabled={readOnly || order.updating || isMarketplaceOrder(order)}
            >
            Créer un lien de paiement
            </Button>
          </td>
        </tr>
      </tbody>
    </Table>
    <PaymentLinkModal
      show={showPaymentLinkModal}
      onHide={() => setShowPaymentLinkModal(false)}
      order={order}
      user={user}
    />
  </React.Fragment>;
};

InternalOrderActions.propTypes = {
  "order": PropTypes.object,
  "showPopinCredit": PropTypes.func,
  "showPopinReprepare": PropTypes.func,
  "showPopinReDeliver": PropTypes.func,
  "showPopinRefund": PropTypes.func,
  readOnly: PropTypes.bool,
  user: PropTypes.object,
};

export const OrderActions = connect(
  (state) => ({
    pseudoZones: state.support.meta ? state.support.meta.pseudoZones : [],
  }),
  (dispatch) => {
    return {
      "showPopinCredit": (order, user) => {
        dispatch(showPopinOrderCredit(order, user));
      },
      "showPopinReprepare": (order) => {
        dispatch(showPopinReprepareOrderBefore(order));
      },
      "showPopinReDeliver": (order) => {
        dispatch(showPopinReDeliverOrder(order));
      },
      "showPopinRefund": (order) => {
        dispatch(showPopinRefundOrder(order));
      }
    };
  }
)(InternalOrderActions);
